import script from "./GroupManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupManagement.vue?vue&type=script&setup=true&lang=ts"

import "./GroupManagement.vue?vue&type=style&index=0&id=40126ac2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40126ac2"]])

export default __exports__